// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeStandingsGetBody = {
  poolId: string;
  contestId: string;
};

export type typeStandingsGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    entries: {
      entryId: string;
      displayName: string;
      status: "in" | "eliminated" | "revived";
      livesRemaining: number;
      pointsTotal: number;
      rank: number;
      isViewer: boolean;
      wins: number | null;
      losses: number | null;
      roundsPlayed: number | null;
      userId: string;
      photoUrl?: string | null;
      eliminatedAtRoundLabel?: string | null;
      medalsThisSeason: number;
      revivesThisContest: number;
    }[];
  };
};

export type typeStandingsGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStandingsGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStandingsGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaStandingsGetBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    contestId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "contestId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createStandingsGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaStandingsGetBody);
  }

  return async function postStandingsGet(
    payload: typeStandingsGetBody,
  ): Promise<typeStandingsGetOutput200 | typeStandingsGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postStandingsGet" failed before calling the network. #a14c88c767af`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#a14c88c767af" },
        },
        data: null,
      } as typeStandingsGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/standings/get`,
      httpMethod: "POST",
      options,
    })) as typeStandingsGetOutput200 | typeStandingsGetOutput400;
  };
}
